export default __webpack_public_path__ + "static/media/cabourg11.d999a7ff.jpg";